var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwsIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18598",
    "data-name": "Group 18598",
    transform: "translate(-71 -6424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4487",
    "data-name": "Rectangle 4487",
    transform: "translate(71 6424)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Amazon_Web_Services_Logo",
    transform: "translate(71.332 6437.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30297",
    "data-name": "Path 30297",
    d: "M29.935,15.4a6.627,6.627,0,0,0,.241,1.949,11.723,11.723,0,0,0,.7,1.577.953.953,0,0,1,.153.5.867.867,0,0,1-.416.657l-1.38.92a1.05,1.05,0,0,1-.569.2,1.008,1.008,0,0,1-.657-.307,6.776,6.776,0,0,1-.788-1.029c-.219-.372-.438-.788-.679-1.292A8.091,8.091,0,0,1,20.1,21.6a6,6,0,0,1-4.38-1.577A5.626,5.626,0,0,1,14.1,15.818a5.638,5.638,0,0,1,1.993-4.512A7.968,7.968,0,0,1,21.459,9.6a17.341,17.341,0,0,1,2.322.175c.81.11,1.643.285,2.519.482v-1.6a4.853,4.853,0,0,0-1.029-3.5A5.041,5.041,0,0,0,21.7,4.144a9.965,9.965,0,0,0-2.365.285,17.451,17.451,0,0,0-2.365.745,6.284,6.284,0,0,1-.767.285,1.343,1.343,0,0,1-.35.066c-.307,0-.46-.219-.46-.679V3.772a1.386,1.386,0,0,1,.153-.767,1.64,1.64,0,0,1,.613-.46,12.609,12.609,0,0,1,2.76-.986,13.279,13.279,0,0,1,3.417-.416c2.606,0,4.512.591,5.738,1.774a7.248,7.248,0,0,1,1.818,5.388v7.1Zm-8.892,3.329a7.1,7.1,0,0,0,2.256-.394,4.881,4.881,0,0,0,2.081-1.4,3.476,3.476,0,0,0,.745-1.4,7.863,7.863,0,0,0,.219-1.905v-.92a18.291,18.291,0,0,0-2.015-.372,16.5,16.5,0,0,0-2.059-.131,5.049,5.049,0,0,0-3.263.876A3.053,3.053,0,0,0,17.933,15.6a2.826,2.826,0,0,0,3.11,3.132ZM38.63,21.1a1.223,1.223,0,0,1-.832-.219,1.785,1.785,0,0,1-.46-.854L32.191,3.093a3.837,3.837,0,0,1-.2-.876.48.48,0,0,1,.526-.548h2.146a1.214,1.214,0,0,1,.854.219,1.792,1.792,0,0,1,.438.854l3.68,14.5,3.417-14.5a1.536,1.536,0,0,1,.416-.854,1.507,1.507,0,0,1,.876-.219H46.1a1.318,1.318,0,0,1,.876.219,1.476,1.476,0,0,1,.416.854l3.46,14.674L54.64,2.743a1.878,1.878,0,0,1,.438-.854,1.429,1.429,0,0,1,.854-.219h2.037a.487.487,0,0,1,.548.548,2.184,2.184,0,0,1-.044.35,3.117,3.117,0,0,1-.153.548l-5.278,16.93a1.679,1.679,0,0,1-.46.854,1.4,1.4,0,0,1-.832.219H49.866a1.318,1.318,0,0,1-.876-.219,1.553,1.553,0,0,1-.416-.876L45.179,5.9,41.806,20a1.71,1.71,0,0,1-.416.876,1.358,1.358,0,0,1-.876.219Zm28.144.591a14.493,14.493,0,0,1-3.373-.394,9.964,9.964,0,0,1-2.519-.876A1.578,1.578,0,0,1,60.2,19.8a1.546,1.546,0,0,1-.131-.613V18.074c0-.46.175-.679.5-.679a1.24,1.24,0,0,1,.394.066c.131.044.329.131.548.219a11.913,11.913,0,0,0,2.409.767,13.153,13.153,0,0,0,2.606.263,5.909,5.909,0,0,0,3.2-.723,2.359,2.359,0,0,0,1.139-2.081,2.133,2.133,0,0,0-.591-1.533,5.5,5.5,0,0,0-2.212-1.139l-3.176-.986a6.68,6.68,0,0,1-3.5-2.234,5.218,5.218,0,0,1-1.1-3.176,4.874,4.874,0,0,1,.591-2.431,5.631,5.631,0,0,1,1.577-1.8,6.951,6.951,0,0,1,2.278-1.139A9.546,9.546,0,0,1,67.5,1.1a11,11,0,0,1,1.467.088c.5.066.964.153,1.424.241.438.11.854.219,1.248.35a4.78,4.78,0,0,1,.92.394,1.894,1.894,0,0,1,.657.548,1.18,1.18,0,0,1,.2.723V4.473c0,.46-.175.7-.5.7a2.278,2.278,0,0,1-.832-.263,10.02,10.02,0,0,0-4.205-.854,5.653,5.653,0,0,0-2.913.613,2.115,2.115,0,0,0-1.029,1.949,2.068,2.068,0,0,0,.657,1.555,6.542,6.542,0,0,0,2.409,1.2l3.11.986a6.661,6.661,0,0,1,3.395,2.1,4.956,4.956,0,0,1,1.007,3.066,5.631,5.631,0,0,1-.569,2.541A5.89,5.89,0,0,1,72.337,20a7.06,7.06,0,0,1-2.431,1.227A10.415,10.415,0,0,1,66.774,21.688Z",
    transform: "translate(-9.709)",
    fill: "#252f3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18597",
    "data-name": "Group 18597",
    transform: "translate(1.668 25.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30298",
    "data-name": "Path 30298",
    d: "M61.2,124.521c-7.206,5.322-17.675,8.148-26.676,8.148A48.261,48.261,0,0,1,1.96,120.251c-.679-.613-.066-1.446.745-.964a65.681,65.681,0,0,0,32.59,8.651,65.035,65.035,0,0,0,24.859-5.081C61.358,122.309,62.387,123.645,61.2,124.521Z",
    transform: "translate(-1.668 -117.84)",
    fill: "#f90",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30299",
    "data-name": "Path 30299",
    d: "M255.013,116.457c-.92-1.183-6.089-.569-8.432-.285-.7.088-.81-.526-.175-.986,4.118-2.891,10.885-2.059,11.674-1.1.788.986-.219,7.753-4.074,10.995-.591.5-1.161.241-.9-.416C253.984,122.5,255.933,117.618,255.013,116.457Z",
    transform: "translate(-192.476 -113.192)",
    fill: "#f90",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsIcon1);
export default __webpack_public_path__ + "static/media/AWS-icon (1).a817c6d2b97605bcc5f74c293ce8a4ae.svg";
export { ForwardRef as ReactComponent };